import { queryShopifyStorefront } from '@/services/shopifyStorefront'

const BEST_SELLING_QUERY = `
  query getBestSelling($handles: String!) {
    products(first: 250, sortKey: BEST_SELLING, query: $handles) {
      edges {
        node {
          id
          handle
        }
      }
    }
  }
`

let bestSellerCache = null
let lastFetchTime = null
const CACHE_DURATION = 1000 * 60 * 60 // 1 hour

export const getBestSellerRanking = async (productHandles = []) => {
  const cacheKey = productHandles.sort().join(',')

  // Return cached data if available and fresh
  if (bestSellerCache?.[cacheKey] && lastFetchTime && (Date.now() - lastFetchTime < CACHE_DURATION)) {
    return bestSellerCache[cacheKey]
  }

  try {
    // Create handles query string for filtering
    const handlesQuery = productHandles.length
      ? productHandles.map(handle => `handle:${handle}`).join(' OR ')
      : ''

    const data = await queryShopifyStorefront({
      query: BEST_SELLING_QUERY,
      variables: {
        handles: handlesQuery
      }
    })

    if (!data?.products?.edges) {
      return []
    }

    // Transform the data into our ranking format
    const rankings = data.products.edges.map(({ node }) => ({
      id: node.id,
      handle: node.handle
    }))

    // Cache the results
    bestSellerCache = {
      ...bestSellerCache,
      [cacheKey]: rankings
    }
    lastFetchTime = Date.now()

    return rankings
  } catch (error) {
    return []
  }
}